import logo from './logo.png';
import heroimg1 from './fractile.webp';
import whitelogo from './whitelogo.png';
import linkedin from './linkedin.svg';
import homeabout from './home_about-1.webp';
import vector from './Vector.png';
import aboutimg from './about/aboutimg.webp';
import aboutimg1 from './about/aboutimg1.png';
import constructionimg from './construction.webp';
import ourMissionimg1 from './about/ourMission1.webp';
import challangesecimage from './about/challangessec1.webp';
import ourVision from './about/ourVision.webp';
import companyImg1 from './company/companyimg.png';
import companyImg2 from './company/companyimg1.png';
import companyImg3 from './company/comapnyimg2.png';
import teammember1 from './team/teamPhoto/team1.webp';
import teammember2 from './team/teamPhoto/team2.webp';
import teammember3 from './team/teamPhoto/team3.webp';
import teammember4 from './team/teamPhoto/team4.webp';
import teammember5 from './team/teamPhoto/team5.webp';
import teammember6 from './team/teamPhoto/team6.webp';
import teammember7 from './team/teamPhoto/team7.webp';
import teammember8 from './team/teamPhoto/team8.webp';
import teammember9 from './team/teamPhoto/team9.webp';
import teammember10 from './team/teamPhoto/team10.webp';
import footerbg from './footer-bg.webp';
import sliderElement1 from './slider-element-1.webp';
import sliderElement2 from './slider-element-2.webp';
import sliderElement3 from './slider3-element-1.webp';
import sliderElement4 from './slider3-element-2.webp';
import building1 from './Part1.png';
import building2 from './Part2.png';
import building3 from './Part3.png';
import twodto3d from './services/2dto3d.webp';
import twodto3d2 from './services/2dto3d2.webp';
import threedwalkthrough from './services/3dwalkthrough.webp';
import threedwalkthrough2 from './services/3dwalkthrough2.webp';
import fourdstilulation from './services/4dstimulation.webp';
import fourdstilulation2 from './services/4dstimulation2.webp';
import BIMStimulation from './services/BIM-execution.webp';
import BIMStimulation2 from './services/BIM-execution2.webp';
import ClashDetection from './services/clashdecetion.webp';
import ClashDetection2 from './services/clashdecetion2.webp';
import supplimental from './services/supplimental.webp';
import supplimental2 from './services/supplimental2.webp';
import BIMexecution from './services/BIM-execution.webp';
import BIMexecution2 from './services/BIM-execution2.webp';
import poinntcloudto3d from './services/pointcloudto3d.webp';
import poinntcloudto3d2 from './services/pointcloudto3d2.webp';
import shpdrawing from './services/shopdrawing.webp';
import shpdrawing2 from './services/shopdrawing2.webp';
import overlay2d from './services/2doverlay.webp';
import overlay2d2 from './services/2doverlay2.webp';
import pmsoftware from './services/pmsoftware.webp';
import pmsoftware2 from './services/pmsoftware2.webp';
import render2dn3d from './services/companyimg.webp';
import render2dn3d2 from './services/3d-house-renders.webp';
import popupbgprop from './team/popupbgimg.png';
import whatwedo from './what-we-do.png';
import industryExperts from './industry-experts.png';
import cuttingEdgeTech from './cutting-edge-tech.png';
import seamlessCollab from './seamleass-collab.png';
import customSol from './custom-solution.png';
import caseStudies1 from './caseStudies1.png';
import educationSectorImg from './education-sector.png';
import constructiomsector from './construction-sector.png';
import healthcaresector from './healthcare-sector.png';
import hospitalitysector from './hospitality-sector.png';
import fbicon from './fb.png';
import instaicon from './insta.png';
import xicon from './x.png'

import logo1 from './Fractile-Logos/logo1.png';
import logo2 from './Fractile-Logos/logo2.png';
import logo3 from './Fractile-Logos/logo3.png';
import logo4 from './Fractile-Logos/logo4.png';
import logo5 from './Fractile-Logos/logo5.png';
import logo6 from './Fractile-Logos/logo6.png';

export const image={
    constructionimg,
    building1,
    building2,
    building3,
    whatwedo,
    industryExperts,
    cuttingEdgeTech,
    seamlessCollab,
    customSol,
    sliderElement3,
    sliderElement4,
    sliderElement1,
    sliderElement2,
    footerbg,
    teammember1,
    teammember2,
    teammember3,
    teammember4,
    teammember5,
    teammember6,
    teammember7,
    teammember8,
    teammember9,
    teammember10,
    // teammember11,
    companyImg1,
    companyImg2,
    companyImg3,
    ourVision,
    challangesecimage,
    ourMissionimg1,
    aboutimg,
    aboutimg1,
    logo,
    heroimg1,
    whitelogo,
    linkedin,
    homeabout,  
    vector,  
    twodto3d,
    twodto3d2,
    threedwalkthrough,
    threedwalkthrough2,
    fourdstilulation,
    fourdstilulation2,
    BIMStimulation,
    BIMStimulation2,
    ClashDetection,
    ClashDetection2,
    supplimental,
    supplimental2,
    BIMexecution,
    BIMexecution2,
    poinntcloudto3d,
    poinntcloudto3d2,
    shpdrawing,
    shpdrawing2,
    overlay2d,
    overlay2d2,
    pmsoftware,
    pmsoftware2,
    render2dn3d,
    render2dn3d2,
    popupbgprop,
    caseStudies1,
    educationSectorImg,
    constructiomsector,
    healthcaresector,
    hospitalitysector,
    fbicon,
    instaicon,
    xicon,
    logo1,
    logo2,
    logo3,
    logo4,
    logo5,
    logo6,
}